<template lang="pug">
  .op-modal
    .op-modal__title
      h2.title Принять заявку
    .op-modal__body
      .form
        .form__elem
          .form-elem(
            :class="{ 'form-elem_error checkbox': errors.contractModel }"
          )
            .form-elem__title 1. Договор
            .form-elem__body
              .input-item
                .input-item__input
                  label.checkbox
                    input.checkbox__input(
                      type="checkbox"
                      v-model="contractModel"
                      @change="keymonitor()"
                    )
                    .checkbox__icon
                .input-item__body
                  .input-item__text Сформировать договор
        .form__elem
          .form-elem(
            :class="{ 'form-elem_error checkbox': errors.receiptModel }"
          )
            .form-elem__title 2. Квитанция
            .form-elem__body
              .input-item
                .input-item__input
                  label.checkbox
                    input.checkbox__input(
                      type="checkbox"
                      v-model="receiptModel"
                      @change="keymonitor()"
                    )
                    .checkbox__icon
                .input-item__body
                  .input-item__text Сформировать квитанцию
        .form__elem
          .form-elem(
            :class="{ 'form-elem_error': errors.addressModel }"
          )
            .form-elem__title 3. Куда нужно явиться для подачи оригиналов документов
            .form-elem__body
              input.input.input_full(
                placeholder="Адрес"
                v-model="addressModel"
                v-on:keyup="keymonitor"
              )
        .form__elem
          .form-elem(
            :class="{ 'form-elem_error': errors.dateModel }"
          )
            .form-elem__title 4. Крайний срок подачи оригиналов и оплаты
            .form-elem__body
              date-picker(
                placeholder="дд.мм.гггг"
                v-model="dateModel"
                format="DD.MM.YYYY"
                lang="ru"
                input-class="input input_full"
                @change="onChangeDate($event)"
                :clearable="false"
                :editable="false"
              )
        .form__elem.form__elem_button
          .form-elem
            .form-elem__body
              button.button.button_paint-secondary.button_long(
                type="submit"
                @click="onSubmit()"
              )
                .button__text Отправить
            .form-elem__error(v-show="showErrorInfo") Не все поля заполнены
</template>

<script>
import DatePicker from "vue2-datepicker";

export default {
  name: "OperatorAccept",
  components: {
    DatePicker
  },
  props: ["onSubmitModal", "onCloseModal"],
  data() {
    return {
      showErrorInfo: false,
      contractModel: false,
      receiptModel: false,
      addressModel: "г. Казань, ул. Н. Столбова, д.2, эт. 4, оф. 410-416",
      dateModel: "",
      dateOriginalDeadline: "",
      errors: {
        contractModel: false,
        receiptModel: false,
        addressModel: false,
        dateModel: false
      }
    };
  },
  methods: {
    keymonitor() {
      this.showErrorInfo = false;
      this.errors = {
        contractModel: false,
        receiptModel: false,
        addressModel: false,
        dateModel: false
      };
    },
    onChangeDate(date) {
      const d = new Date(date);
      const _date = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(
        -2
      )}-${("0" + d.getDate()).slice(-2)}`;
      this.dateModel = _date;
      this.dateOriginalDeadline = _date;
    },
    onSubmit() {
      const errors = [];
      Object.keys(this.errors).map(error => {
        if (!this[error] || this[error].length === 0) {
          errors.push(error);
          this.errors[error] = true;
        }
      });
      if (errors.length > 0) {
        return;
      }
      this.onCloseModal();
      this.onSubmitModal(
        {
          comment: this.addressModel,
          date_originals_deadline: this.dateOriginalDeadline
        },
        5
      );
    }
  }
};
</script>
